"use client";

import React from "react";
import { useLeftSideBarStore } from "~/state/store";
import { cn } from "~/utils/fontsConfig";
import { If } from "../Conditional";
import CommunitySidebar from "../community-components/CommunitySideBar";

type Props = {
    children: React.ReactNode;
    slug: string;
    approxLocation: string;
    showSidebar?: boolean;
};

const CommunityViewLayout = ({
    children,
    slug,
    approxLocation,
    showSidebar = true,
}: Props) => {
    const sideBarState = useLeftSideBarStore((state) => state.sideBarState);
    const isSidebarVisible = sideBarState === "community-management";

    return (
        <div className="flex min-h-screen w-full flex-row gap-4 lg:justify-center">
            {/* Desktop Sidebar */}
            {showSidebar && (
                <>
                    <span className="hidden lg:block">
                        <CommunitySidebar communitySlug={slug} />
                    </span>

                    {/* Mobile Sidebar */}
                    <If condition={isSidebarVisible}>
                        <div className="fixed inset-0 z-20 mt-[80px] block lg:hidden">
                            <CommunitySidebar communitySlug={slug} />
                        </div>
                    </If>
                </>
            )}

            <div
                className={cn(
                    "mt-6 flex-1",
                    "flex items-start justify-center",
                    isSidebarVisible &&
                        "blur-sm filter lg:blur-none lg:filter-none",
                )}
            >
                {children}
            </div>
        </div>
    );
};

export default CommunityViewLayout;
